import { FC, useEffect, useState } from "react";
import { FullWidthButton } from "src/framework/components/buttons";
import { InputInfo, InputText } from "src/framework/components/forms";
import { JobsType } from "src/types";

interface JobsFormProperties {
    job: JobsType;
    onClose: () => void;
    onConfirmar: (value: JobsType) => void;
}

const JobsForm: FC<JobsFormProperties> = ({
    job,
    onClose,
    onConfirmar,
}) => {

    const [jobState, setJobState] = useState<JobsType>();

    useEffect(() => {
        setJobState(job);
    }, [job]);

    return <>
        <div className="JobsForm">
            <div className="row">
                <div className="X12 12">
                    <InputInfo label="Id Job" text={jobState?.id || "-"} />
                </div>
                <div className="X12 12">
                    <InputText
                        label="Nome Job *"
                        fullWidth
                        //error={errorState.documento.hasError}
                        value={jobState?.nome}
                        onChange={(e: any) => {

                            const value = e.target.value;

                            const state = { ...jobState };
                            state.nome = value;
                            setJobState(state);
                        }}
                    />
                </div>
                <div className="X12 12">
                    <InputText
                        label="Expressão Cron *"
                        fullWidth
                        //error={errorState.documento.hasError}
                        value={jobState?.expressao}
                        onChange={(e: any) => {

                            const value = e.target.value;

                            const state = { ...jobState };
                            state.expressao = value;
                            setJobState(state);
                        }}
                    />
                </div>
                <div className="row actions">
                    <div className="X12 M6 X--order2 M--order1">
                        <FullWidthButton
                            text="Cancelar"
                            onClick={() => {
                                if (onClose) {
                                    onClose();
                                }
                            }}
                        />
                    </div>
                    <div className="X12 M6 X--order1 M--order2">
                        <FullWidthButton
                            text="Confirmar"
                            variant="contained"
                            color="primary"
                            disableElevation
                            onClick={() => {

                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    </>
}

export { JobsForm }